<div class="redirect-page">
  @if (auth.user | async; as user) {
    <div>
      <h1 class="text-center">Hello {{ user.displayName }}!</h1>
      <h3 class="text-center">We are bringing you to the next page</h3>
    </div>
  }
</div>
